export default angular.module("mars.vet.dnareports.controllers.exceptionletter",[]).controller('ExceptionLetterController',
        function($rootScope, $scope, $window,
                EntryService, NavigationService, TranslationService, EntryIDService, UtilityService,
                reportdata) {

    'ngInject';

    let resultString = reportdata.resultString;
    let sampleDetails = reportdata.sampleDetails;

    var letter = "/staticresources/dnareports/images/" + resultString.sampleID + "/lettercontent.xml";
    $scope.letterTest = letter;
    var reportType = 'online';
    $scope.onloadFun = function() {
        reportType = 'pdf';
    }
    EntryService.getEntry('57xEDReh84GyeuiCsC4YCW').then(function(response) {
        var fields = response.fields;
        if (reportType != 'pdf') {
            $rootScope.pageTitle = TranslationService.getTranslation("Notes");
        }
        $scope.title = TranslationService.getTranslation("Notes");
        $scope.lastName = sampleDetails.ownerName.lastName;
        $scope.firstName = sampleDetails.ownerName.firstName;
        $scope.attentionMsg = "Attenion! " + $scope.lastName;
        var letterContent = "";
        var d = resultString.event[0]['eventDate'];
        var letterFlag = resultString.event[0]['letterflag'];
        $scope.date = UtilityService.formatDate(d);
        if (letterFlag == 'REVISED') {
            letterContent = fields.exceptionLetters['RevisedReport'];
        } else if (letterFlag == 'AUTODETAILED') {
            letterContent = fields.exceptionLetters['DetailedAnalysis'];
        } else if (letterFlag == 'REPEAT') {
            letterContent = fields.exceptionLetters['RepeatTrapped'];
        }
        $scope.exceptionLetter = letterContent.replaceAll('[PETNAME]', sampleDetails.petDetails.petName).replaceAll('[SAMPLEID]', resultString.sampleID).replaceAll('[CLIENT]', $scope.lastName);
        $scope.descriptionArray = [];
        $scope.exceptionLetterFlag = letterFlag;
        angular.forEach($scope.exceptionLetter.split("\n"), function(value, key) {
            if (value != '') {
                $scope.descriptionArray.push(value);
            }
        });
        var init=function(){
	    $rootScope.$broadcast('checkNotifyCount',1);
	    }
	    init();
        $window.ga('send', 'pageview', {
            'page': 'ExceptionLetter'
        });
        // NavigationService.setNavigationUrls();
    }, function(error) {
        // promise rejected, could log the error with:
        // console.log('error', error);
    });
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/exceptionletter.controller.js